
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"15","viewBox":"0 0 16 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.263 2.504L1.01 10.758a.329.329 0 00-.086.15L.01 14.58a.326.326 0 00.393.394l3.672-.915a.324.324 0 00.15-.086L12.48 5.72 9.263 2.504zM14.53 1.379L13.61.46c-.614-.614-1.684-.613-2.297 0l-1.126 1.126 3.217 3.216 1.125-1.125c.307-.307.476-.715.476-1.15 0-.433-.17-.841-.476-1.148z"}})])
          )
        }
      }
    